










import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'Popup',
})
/**
 * @vuese
 * @group Layout
 * Popup layout
 */
export default class Popup extends Vue {
  // [Prop]
  @Prop({ type: Boolean, default: false, required: true }) isDispplay!: boolean

  // [lifecycle]
}
